import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addBankAccount, addBanker, getBank, updateBankAccount, updateBanker } from "../../../services/userMasterUser";

export default function BankAccountCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();
  
  const [bankList, setBankList] = useState([])
  const [input, setInput] = useState({
    name: state?.name || "",
    ifsc: state?.ifsc || "",
    accountHolderName: state?.accountHolderName || "",
    accountNumber: state?.accountNumber || "",
    branch: state?.branch || "",
    category: state?.category || "",
    info: state?.info || "",
    upiInfo: state?.upiInfo || "",
    status: state?.status || "ACTIVE",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    name: "",
    ifsc: "",
    accountHolderName: "",
    accountNumber: "",
    branch: "",
    category: "",
    info: "",
    upiInfo: "",
    status: "",
  });

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }

    if (!(input.ifsc)) {
      newErrors.ifsc = "PLEASE ENTER IFSC";
      isValid = false;
    } else {
      newErrors.ifsc = "";
    }

    
    if (!(input.accountHolderName)) {
      newErrors.accountHolderName = "Please Enter Account Holder Name";
      isValid = false;
    } else {
      newErrors.accountHolderName = "";
    }
    
    if (!(input.accountNumber)) {
      newErrors.accountNumber = "Please Enter Account Number";
      isValid = false;
    } else {
      newErrors.accountNumber = "";
    }
    
    if (!(input.branch)) {
      newErrors.branch = "Please Enter Branch";
      isValid = false;
    } else {
      newErrors.branch = "";
    }
    
    if (!(input.category)) {
      newErrors.category = "Please Enter Category";
      isValid = false;
    } else {
      newErrors.category = "";
    }
    
    if (!(input.info)) {
      newErrors.info = "Please Enter Info";
      isValid = false;
    } else {
      newErrors.info = "";
    }
    
    if (!(input.upiInfo)) {
      newErrors.upiInfo = "Please Enter Upi Info";
      isValid = false;
    } else {
      newErrors.upiInfo = "";
    }
    
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input?.name,
          ifsc: input?.ifsc,
          accountHolderName: input?.accountHolderName,
          accountNumber: input?.accountNumber,
          branch: input?.branch,
          category: input?.category,
          info: input?.info,
          upiInfo: input?.upiInfo,
          status: input.status,
        };
        updateBankAccount(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/bank-account/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input?.name,
          ifsc: input?.ifsc,
          accountHolderName: input?.accountHolderName,
          accountNumber: input?.accountNumber,
          branch: input?.branch,
          category: input?.category,
          info: input?.info,
          upiInfo: input?.upiInfo,
          status: input.status,

        };
        addBankAccount(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/bank-account/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/banker/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Bank Account {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="ifsc" className="form-label">
                        IFSC
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="ifsc"
                        name="ifsc"
                        value={input.ifsc}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            ifsc: e.target.value,
                          });
                        }}
                        required
                      />
                       
                      <div className="text-danger">{errors.ifsc}</div>
                    </div>
                    
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="accountHolderName" className="form-label">
                        Account Holder Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="accountHolderName"
                        name="accountHolderName"
                        value={input.accountHolderName}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            accountHolderName: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.accountHolderName}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Account Number
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="accountNumber"
                        name="accountNumber"
                        value={input.accountNumber}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            accountNumber: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.accountNumber}</div>
                    </div>
                   
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Branch
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="branch"
                        name="branch"
                        value={input.branch}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            branch: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.branch}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Category
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="category"
                        name="category"
                        value={input.category}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            category: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.category}</div>
                    </div>
                    
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Info
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="info"
                        name="info"
                        value={input.info}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            info: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.info}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Upi Info
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="upiInfo"
                        name="upiInfo"
                        value={input.upiInfo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            upiInfo: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.upiInfo}</div>
                    </div>
                  </div>

                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}

                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
